import { render, staticRenderFns } from "./ListSessaoViewDetalhes.vue?vue&type=template&id=1ed17d22&"
import script from "./ListSessaoViewDetalhes.vue?vue&type=script&lang=js&"
export * from "./ListSessaoViewDetalhes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports